<div class="logo-container">
  <div class="logo">
    <img class="logo-image" [src]="customIconLocation" alt="Logo" *ngIf="customIconLocation">
    <img class="logo-image" src="assets/img/logo-4.png" alt="Logo">
  </div>
  <div class="headings">
    <div class="title">Smart<span class="dine">Dine</span></div>
    <ng-content select="[heading]"></ng-content>
  </div>
</div>
<ng-content></ng-content>